/**
 * url-sync — History API helpers for the variant picker.
 *
 * Reads and writes ?pf_<optionName>= params for cross-page selection persistence.
 * Falls back gracefully when History API is unavailable.
 */

/**
 * Normalise an option name to a URL param key.
 * e.g. "Rope Color" → "pf_rope_color"
 * @param {string} name
 * @returns {string}
 */
export function optionNameToParam(name) {
  return `pf_${name.toLowerCase().replace(/\s+/g, '_')}`;
}

/**
 * Build a URL for a sibling product, carrying the current selection forward.
 * @param {string} handle          Shopify product handle
 * @param {Record<string,string>} selection
 * @returns {string}
 */
export function buildRedirectUrl(handle, selection) {
  const url = new URL(`/products/${handle}`, window.location.origin);
  for (const [name, value] of Object.entries(selection)) {
    url.searchParams.set(optionNameToParam(name), value);
  }
  return url.toString();
}

/**
 * Replace the browser URL with ?variant=<id> and pf_ params for the current selection.
 * No-ops when data-update-url is "false".
 *
 * @param {string} productUrl    e.g. "/products/my-product"
 * @param {string|number} variantId
 * @param {Record<string,string>} selection
 * @param {boolean} updateUrl
 */
export function pushVariantUrl(productUrl, variantId, selection, updateUrl) {
  if (!updateUrl) return;
  const url = new URL(productUrl, window.location.origin);
  if (variantId) url.searchParams.set('variant', String(variantId));
  for (const [name, value] of Object.entries(selection)) {
    url.searchParams.set(optionNameToParam(name), value);
  }
  window.history.replaceState({}, '', url.toString());
}
